/**
 * The sorting direction.
 * !! IMPORTANT: Do not change the values, they are used in functions from 3rd party libraries.
 * @type {Readonly<{ASCENDING: 'asc', DESCENDING: 'desc'}>}
 */
export const SortDirection = Object.freeze({
  ASCENDING: 'asc',
  DESCENDING: 'desc',
});
